import { Component } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/core/service/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    imports: [CommonModule, AsyncPipe],
    standalone: true,
})
export class LoaderComponent {
    isLoading$: Observable<boolean>;

    constructor(private readonly loaderService: LoaderService) {
        this.isLoading$ = this.loaderService.loading$;
    }
}
